var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showHistogram)?_c('div',{staticClass:"histogram-div"},[_c('Histogram',{attrs:{"colors":_vm.colors,"extend":_vm.extend,"data":_vm.data}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }